import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { TrelloCard } from '../../../trello-misc/data/trello-card';
import { User } from 'projects/core/src/lib/login/data/user';

@JsonObject('model.project.ProjectParticipant')
export class ProjectParticipant extends AbstractModel {

    @JsonProperty(Number, 'id')
    id: number;

    @JsonProperty(User, 'user')
    user?: User;

    @JsonProperty([String], 'types')
    types?: string[];

}